import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchLockerQty } from '../actions/objectives';
import LockerQtyFilterForm from '../forms/LockerQtyFilterForm';
import ErrorMessage from '../components/ErrorMessage';
import LoadingProgress from '../components/LoadingProgress';
import Box from '../components/Box'
import { formValueSelector } from 'redux-form';

const selector = formValueSelector('LockerQtyFilterForm');

class LockerQtyView extends React.Component {

  renderTable() {
    const { objectives, loading, error } = this.props.objectives;

    if (loading) return <LoadingProgress />;
    if (error) return <ErrorMessage message={error.message || error} />;
    if (!Array.isArray(objectives)) {
      return <div>No data available.</div>; // Or show nothing/null
    }
    return (
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Locker</th>
            <th>Ventas</th>
          </tr>
        </thead>
        <tbody>
          {objectives.map((row, idx) => (
            <tr key={idx}>
              <td>{row.Locker}</td>
              <td>{row.SalesCount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  renderTotals() {
    const { machines, objectives, selectedCustomer, selectedMachine } = this.props;

    // Filter machines based on customer and machine selection
    const filteredMachines = Array.isArray(machines)
      ? machines.filter(m =>
        (!selectedCustomer || (m.Customer && m.Customer._id === selectedCustomer)) &&
        (!selectedMachine || m._id === selectedMachine)
      )
      : [];

    const totalLastIndex = filteredMachines.reduce((sum, m) => sum + (m.LastIndex || 0), 0);
    const totalCapacity = filteredMachines.reduce((sum, m) => sum + (m.Capacity || 0), 0);

    const salesData = Array.isArray(objectives?.objectives) ? objectives.objectives : [];

    const totalSales = salesData.reduce((sum, o) => sum + (o.SalesCount || 0), 0);
    const avgSalesPerLocker = filteredMachines.length
      ? (totalSales / totalLastIndex).toFixed(2)
      : '0.00';

    const utilizationRate = totalCapacity
      ? ((salesData.length / totalLastIndex) * 100).toFixed(1)
      : '0.0';

    const activeLockers = salesData.length;
    const idleLockers = totalLastIndex - activeLockers;

    const topLocker = salesData.reduce((top, curr) =>
      !top || curr.SalesCount > top.SalesCount ? curr : top,
      null
    );

    return (
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Total Ventas</th>
            <th>Total Taquillas</th>
            <th>Promedio Ideal</th>
            <th>Utilización (%)</th>
            <th>Taquillas Activas</th>
            <th>Taquillas Inactivas</th>
            <th>Top Taquilla</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{totalSales.toLocaleString()}</td>
            <td>{totalLastIndex.toLocaleString()}</td>
            <td>{avgSalesPerLocker}</td>
            <td>{utilizationRate}%</td>
            <td>{activeLockers}</td>
            <td>{idleLockers}</td>
            <td>{topLocker?.Locker || '-'}</td>
          </tr>
        </tbody>
      </table>
    );
  }


  render() {
    return (
      <div>
        <div className="row mb-2">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <h1 className="text-vw-dark">
              LOCKERS POR CANTIDAD
            </h1>
          </div>
        </div>
        <hr className="bg-vw-light" />
        <Box title="Filtro" icon="filter">
          <LockerQtyFilterForm />
        </Box>
        <Box title="Totales" icon="filter">
          {this.renderTotals()}
        </Box>
        <Box title="Listado" icon="filter">
          {this.renderTable()}
        </Box>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  objectives: state.objectives,
  machines: state.machines.machines,
  selectedCustomer: selector(state, 'Customer'),
  selectedMachine: selector(state, 'Machine')
});


const mapDispatchToProps = dispatch => ({
  fetchLockerQty: bindActionCreators(fetchLockerQty, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LockerQtyView);
